import { authEndpoints } from '@/services/endpoints/auth'
import { businessEndpoints } from '@/services/endpoints/business'
import { campaignEndpoints } from '@/services/endpoints/campaign'
import { entityEndpoints } from '@/services/endpoints/entity'
import { miscEndpoints } from '@/services/endpoints/misc'
import { priceAlertEndpoints } from '@/services/endpoints/priceAlert'
import { productEndpoints } from '@/services/endpoints/product'
import { subscriptionEndpoints } from '@/services/endpoints/subscriptions'

const endpoints = {
  AUTH: authEndpoints,
  BUSINESS: businessEndpoints,
  MISC: miscEndpoints,
  ENTITIES: entityEndpoints,
  CAMPAIGNS: campaignEndpoints,
  PRODUCTS: productEndpoints,
  PRICE_HISTORY: priceAlertEndpoints,
  SUBSCRIPTIONS: subscriptionEndpoints,
}

export default endpoints
